import { getDataFromLocalDb, insertDataIntoLocalDB } from "../../services/dbService";
import { getOutletApprovalData } from "../../services/manageOrderService";
import { ChannelkartNetworkGet, ChannelkartNetworkPost, ChannelkartNetworkPut } from "../../services/networkService";
import { getOutletDetailsForSecondary } from "../createSecondaryOrder/CreateSecondaryOrderService";
export const customSxOutletForm = {
  "& .MuiOutlinedInput-root": {
    height: "38px",
    "& fieldset": {
      borderColor: "#EBEBEB",
    },
    "&:hover fieldset": {
      borderColor: "#EBEBEB",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#EBEBEB",
    },
    "&.Mui-disabled fieldset": {
      borderColor: "#EBEBEB !important",
    },
    "&.Mui-disabled": {
      backgroundColor: "transparent",
    },
  },
  "& .MuiInputBase-input": {
    fontSize: "14px",
    fontWeight: 400,
    color: "#464646 !important",
    "&.Mui-disabled": {
      color: "#464646 !important",
    },
    "&:not(:empty)": {
      paddingTop: "3px", 
      marginTop: "9px"
    },
  },
  "& .MuiInputLabel-root": {
    fontSize: "12px",
    color: "rgba(0, 0, 0, 0.6)",
    "&.Mui-focused, &.MuiInputBase-input:not(:empty) + .MuiInputLabel-root": {
      marginTop: "3px",
    },
  },
};
export type FormDataType = {
    outletName: string;
    city: string;
    mobileNo: string;
    pincode: string;
    address: string;
    salesRepId: string;
    channel: string;
    email: string;
    managerName: string;
    latitude: string;
    keyAccount: string;
    longitude: string;
    outletClass: string;
    state: string;
    // Add all other form fields here
    // Page 2 fields
    paymentMode: string;
    outletDiscount: string;
    outletAccountNumber: string;
    outletBank: string;
    outletIfscCode: string;
    tcsEligibility: string
    creditLimit: string;
    creditDays: string;
    creditAvailable: string;
    outletCashDiscount: string;
    // page 3 fields
    outletGstin: string;
    outletPan: string;
    shipToGstin: string;
    shipToContactPersonName: string;
    shipToDescription: string;
    shipToAddress: string;
    shipToCity: string;
    shipToContactNo: string;
    shipToPincode: string;
    shipToState: string;
    //page 4
    outletStatus: string;
    outletType: string;
    subChannel: string;
    loyaltyBalance: string;
    walletBalance: string;
    outletPriceGroup: string;
    outletCategory: string;
    outletRoute: string;
    supplierName: string;
    salesRepName: string;
};

const keys = [
  "outletName", "city", "mobileNo", "pincode", "address", "salesRepId", "channel", "email", "managerName",
  "latitude", "keyAccount", "longitude", "outletClass", "state",
  "paymentMode", "outletDiscount", "outletAccountNumber", "outletBank", "outletIfscCode", "tcsEligibility",
  "creditLimit", "creditDays", "outletCashDiscount",
  "outletGstin", "outletPan", "shipToGstin", "shipToContactPersonName", "shipToDescription",
  "shipToAddress", "shipToCity", "shipToContactNo", "shipToPincode", "shipToState",
  "outletStatus", "outletType", "subChannel", "loyaltyBalance", "walletBalance", "outletPriceGroup",
  "outletCategory", "outletRoute"
];

export const keysToAddConfig = (optionalKeys: Set<string>) => {
  const map = new Map<string, boolean>();

  for (const key of keys) {
    map.set(key, !optionalKeys.has(key)); // true if not in optionalKeys
  }

  return map;
};


export const getValidateRequestBodyForOutletForm = async (outletData?: FormDataType, defaultCreditLimit?:string, defaultCreditDays?: string) => {
  if (!outletData) return null;

  const dbResult = await getDataFromLocalDb("RouteNameIdMapping");
  const routeIdNameMapping = dbResult?.data?.[0]?.data ?? {};

  const {
    outletName,
    city,
    mobileNo,
    pincode,
    address,
    salesRepId,
    channel,
    email,
    managerName,
    latitude,
    keyAccount,
    longitude,
    outletClass,
    state,
    paymentMode,
    creditDays,
    outletDiscount,
    creditLimit,
    outletAccountNumber,
    outletIfscCode,
    outletBank,
    outletCashDiscount,
    outletGstin,
    outletPan,
    shipToGstin,
    shipToContactPersonName,
    shipToDescription,
    shipToAddress,
    shipToCity,
    shipToContactNo,
    shipToPincode,
    shipToState,
    outletStatus,
    outletType,
    subChannel,
    loyaltyBalance,
    walletBalance,
    outletPriceGroup,
    tcsEligibility,
    outletRoute,
    outletCategory,
    supplierName,
    salesRepName,
    creditAvailable,
  } = outletData;

  const routeName =  routeIdNameMapping?.[outletRoute]?.filter1 

  const creditStatus = (creditAvailable === creditLimit) ? "PAID" : "UNPAID"
  const parseOrDefault = (value: any, fallback: any) =>
    value !== undefined && value !== null && value !== "" ? parseFloat(value) : parseFloat(fallback ?? "");

  const parsedData = {
    creditLimit: parseOrDefault(creditLimit.trim(), defaultCreditLimit),
    creditDays: parseOrDefault(creditDays.trim(), defaultCreditDays),
  };
  const payload = {
    outletDetails: {
      activeStatus: outletStatus,
      activeStatusReason: "ComingThroughMDM",
      outletName: outletName.trim(),
      address: address.trim(),
      contactno: mobileNo.trim(),
      channel: channel,
      email: email.trim(),
      latitude: parseFloat(latitude.trim()) || 0,
      longitude: parseFloat(longitude.trim()) || 0,
      outletCategory: outletCategory,
      outletClass: outletClass,
      outletType: outletType,
      priceListId: outletPriceGroup,
      immediateParent: salesRepId,
      account: outletAccountNumber.trim(),
      tinNo: "",
      marketName: "",
      marketId: "",
      outletDivision: "",
      distributionChannel: "all",
      subChannel: subChannel,
      beat: outletRoute,
      beatName: routeName,
      mapped: true,
      source: "Newmapping",
      location: {
        region: "",
        country: "India",
        zone: "",
        area: "",
        town: city,
        branch: "",
        state: state,
        city: city,
        pincode: pincode.trim(),
        outletStateCode: "",
      },
      extendedAttributes: {
        VPO: "",
        shipTo: {
          city: shipToCity,
          state: shipToState,
          address: shipToAddress.trim(),
          pincode: shipToPincode.trim(),
          contactNo: shipToContactNo.trim(),
          stateCode: "",
          contactName: shipToContactPersonName.trim(),
          description: shipToDescription.trim(),
        },
        address: address.trim(),
        salesrep: salesRepId,
        IsTaxable: "",
        salesMode: "",
        keyAccount: keyAccount,
        cashDiscount: outletCashDiscount.trim(),
        "parent-0-1-id": managerName,
        priceListId: outletPriceGroup,
        walletbalance: walletBalance.trim(),
        loyaltybalance: loyaltyBalance.trim(),
        tcsEligibility: tcsEligibility,
        discountPercentage: outletDiscount.trim(),
        preferredPaymentMode: paymentMode,
        approval: "true",
        counterSalesOutletDMS: true,
        source: "DMS",
        supplierName: supplierName,
        salesRepName: salesRepName,
        pincode: pincode.trim(),
      },
      keyAccount: keyAccount,
      paymentMode: paymentMode //"Credit" / "Cash"
    },
    creditStatus: {
      totalDueDays: parsedData.creditDays,
      creditLimit: parsedData.creditLimit,
      creditAvailable: parsedData.creditLimit,
      supplier : managerName,
    },
    accountInfo: {
      extraAttributes: {
        shipTo: {
          gstin: shipToGstin.trim(),
          pan: outletPan.trim(),
        },
        gspUserName: "",
        gspPassword: "",
        outletBank: outletBank.trim(),
      },
      pan: outletPan.trim(),
      gstin: outletGstin.trim(),
      accountNumber: outletAccountNumber.trim(),
      ifsc: outletIfscCode.trim(),
    },
    outletMapping: {
      "salesrep": salesRepId,
      "distributor": managerName
    }
  };

  return payload;
};

const getRequestBodyForOutletUpdate = async (outletData?: FormDataType, duplicateOutletData?:any) => {
  if (!outletData || !duplicateOutletData.outletCode) return null;
  const {
    outletName,
    salesRepId,
    managerName,
    supplierName,
    outletRoute,
    salesRepName,
  } = outletData;

  const dbResult = await getDataFromLocalDb("RouteNameIdMapping");
  const routeIdNameMapping = dbResult?.data?.[0]?.data ?? {};
  const beatIds = duplicateOutletData?.beat?.split(",") ?? [];
  beatIds.push(outletRoute);

  const beatNames = beatIds
    .map((id: string) => routeIdNameMapping?.[id]?.filter1)
    .filter(Boolean); 

  const concatenatedSalesrepId = duplicateOutletData?.immediateParent + "," + salesRepId;
  const concatenatedSalesrepName = duplicateOutletData?.extendedAttributes?.salesRepName + "," + salesRepName;
  const concatenatedBeat = duplicateOutletData?.beat + "," + outletRoute;
  const concatenatedSupplier = (duplicateOutletData?.extendedAttributes?.["parent-0-1-id"] ?? duplicateOutletData?.extendedAttributes?.["parent-1-0-id"] ?? duplicateOutletData?.extendedAttributes?.["distributor"] ?? "") + "," + managerName;
  const concatenatedSupplierName = duplicateOutletData?.extendedAttributes?.supplierName + "," + supplierName;
  const concatenatedBeatName = beatNames.join(",");

  const finalSalesRepId = stringConversion(concatenatedSalesrepId);
  const finalSalesRepName = stringConversion(concatenatedSalesrepName);
  const finalBeat = stringConversion(concatenatedBeat);
  const finalSupplierId = stringConversion(concatenatedSupplier);
  const finalSupplierName = stringConversion(concatenatedSupplierName);
  const finalBeatName = stringConversion(concatenatedBeatName)


  const payload = {
    outletName: outletName,
    outletCode: duplicateOutletData?.outletCode ?? "",
    immediateParent: finalSalesRepId,
    beat: finalBeat,
    beatName: finalBeatName,
    extendedAttributes: {
      salesrep: finalSalesRepId,
      "parent-0-1-id": finalSupplierId,
      distributor: finalSupplierId,
      source: "DMS",
      supplierName: finalSupplierName,
      salesRepName: finalSalesRepName,
    },
  }
  return payload
};

function stringConversion(inputString: string): string {
  const items = inputString.split(",").map(item => item.trim());
  const seen = new Set<string>();
  const result: string[] = [];

  for (const item of items) {
    const lowerItem = item.toLowerCase();
    if (!seen.has(lowerItem) && item !== "") {
      seen.add(lowerItem);
      result.push(item);
    }
  }

  return result.join(",");
}

export interface Feature {
  id: string;
  activeStatus: string;
  changes: any[];
  changed: boolean;
  name: string;
  key1: string;
  key2: string;
  key3: string;
  key4: string;
  timestamp: number;
  rangeKey: number;
  create: boolean;
}
export const createOutlet = async (formData: FormDataType, defaultCreditLimit: string, defaultCreditDays: string) => {
    const payload = await getValidateRequestBodyForOutletForm(formData, defaultCreditLimit, defaultCreditDays)
    try {
        let url = "/outletDetails/registerFinanceData";
        const response = await ChannelkartNetworkPost(url, payload);
        const apiOutletData = response?.data?.feature;
        const newOutletData = {
          ...apiOutletData,
          approvalStatus: "PENDING",
        };
        const existingOutletData = await getDataFromLocalDb("OutletList");
        const newOutletList = [...existingOutletData.data || [], newOutletData];
        await insertDataIntoLocalDB("OutletList", newOutletList);
        return newOutletData;
    }
    catch(err:any){
      console.error("createOutlet error:", err);
      throw err;
    }
}


export const getOutletDetailsForForm = async (property: string): Promise<string[]> => {
  try {
    const url = `/v1/distinctFieldData/OutletDetails/${property}`;
    const response = await ChannelkartNetworkGet(url);
    const data: Array<Record<string, any>> = response.data
    // Extract values and filter out null, undefined, and empty strings
    return data
      .map((item: Record<string, any>) => item[property])
      .filter((value): value is string => typeof value === 'string' && value.trim() !== "");
  } catch (err: any) {
    console.error('Error fetching outlet details:', err.message);
    return [];
  }
};

export const getOutletChannelFields = async () => {
  try{
    const url = `/models/name/outletCategoryMapping?size=10000`
    const response = await ChannelkartNetworkGet(url);
    return response;
  }catch(err){
    console.error('Error fetching outlet details', err);
    return [];
  }
}

export const getSalesRepDataForOutlet = async () => {
  try{
    const designationList = [
      "salesrep", "preseller", "mgr", "dsr", "dbsr", "ssr",
      "psr", "territorymanager", "dse", "rbe", "salesman"
    ];

    // Construct the filter string similar to the original
    const outletCodeFilter = ` and designation[in]:[${designationList.join(",")}]`;

    // Construct the full filter param (no URL encoding here because the API expects it raw)
    const filterParam = `activeStatus:active${outletCodeFilter}`;

    // Your size parameter
    const size = 10000;

    // Compose the new URL path
    const url = `/users/mapped/hierarchy?filter=${encodeURIComponent(filterParam)}&transformerout=outlet_location_transformer&size=${size}`;

    const response = await ChannelkartNetworkGet(url);

    return response?.data?.features?.map((item: any) => ({
      id: item.userAccountId,
      name: item.name // adjust the key if API returns a different one
    })) || [];


  }catch(err:any){
    return []
  }
}

export const fetchSalesrepBeatData = async (salesrepId: string) => {
  const response = await getOutletDetailsForSecondary(salesrepId);

  const uniqueBeats = response.reduce((acc: Set<string>, item: any) => {
    const beat = item?.beat;

    if (typeof beat === "string" && beat.trim()) {
      acc.add(beat.trim()); // add trimmed beat
    }

    return acc;
  }, new Set<string>());

  return Array.from(uniqueBeats);
};

export const getRoutes = async (): Promise<any[]> => {
  try {
    const url = "/v1/route?size=10000";
    const data = await ChannelkartNetworkGet(url);

    const routes = data?.data?.features ?? [];
    return routes
    // Filter by supplier and return only routeCode
    // const filteredRouteCodes = routes
    //   .filter((item: any) => item.salesmanCode === salesrep)
    //   .map((item: any) => item.routeCode);

    // const uniqueRouteCodes: string[] = Array.from(new Set(filteredRouteCodes));

    // return uniqueRouteCodes;

  } catch (err: any) {
    console.error("Error fetching route data:", err);
    return [];
  }
};

export const getSendOtpRequestBody = (mobileNo: string, currentDate: string, designation: string) => {
  return {
    "mobileNumber": mobileNo,
    "extendedAttributes": {
      "activity": "",
      "mobTime": currentDate,
      "designation": designation
    }
  };
}

export const sendOtpOutletCreation = async (requestBody: any) => {
  const response = ChannelkartNetworkPost(
    `/v1/otp/send`, requestBody
  )
  return response;
}

export const getVerifyOtpRequestBody = (mobileNo: string, latitude: string, longitude: string, radiusInMeters: number) => {
  return {
    "mobileNumber": mobileNo,
    "latitude": latitude,
    "longitude": longitude,
    "radiusInMeters": radiusInMeters
  };
}

export const getVerifyOtpRequestHeader = (otp: string) => {
  return {
    "otp" : otp
  };
}

export const sendVerifyOtp = async (requestBody: any, headerBody: any, transformerName: string) => {
  const response = await ChannelkartNetworkPost(`/register/validateGetOutlet?transformerout=${transformerName}`,requestBody, headerBody)
  return response;
}

export enum otpState{
  VALID = "valid",
  INVALID = "invalid"
}


export const updateOutlet = async (formData: FormDataType, duplicateOutletData: any) => {
    const payload = await getRequestBodyForOutletUpdate(formData, duplicateOutletData)
    try {
        let url = `/outletDetails/update?salesrep=${formData.salesRepId}&distributor=${formData.managerName}`;
        await ChannelkartNetworkPut(url, payload);
    }
    catch(err:any){
      console.error("createOutlet error:", err);
      throw err;
    }
}
